/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, Rilievo } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { RilievoService } from '@shared/services/rilievo.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalPianoRilieviComponent } from '../modal-piano-rilievi/modal-piano-rilievi.component';

@Component({
    selector: 'app-toolkit-opera-tab-piano-rilievi',
    templateUrl: './tab-piano-rilievi.component.html',
})
export class ToolkitGestioneOperaTabPianoRilieviComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    @Input() datalist: DatalistAnagrafica;
    public item: Rilievo;

    constructor(
        private modalService: NgbModal,
        private operaService: OperaService,
        private utilsService: UtilsService,
        private rilievoService: RilievoService,
        private router: Router
    ) { }

    ngOnInit() {
        if(this.formGroup.get('idRilievo')?.value !== null && this.formGroup.get('idRilievo')?.value !== undefined) {
            this.rilievoService.read(this.formGroup.get('idRilievo')?.value).subscribe((item) => {
                this.item = item;
            });
        }
    }


    public addItem() {
        if(this.item) {
            this.utilsService.showWarning('L\'opera ha già un rilievo associato. Eliminare il rilievo dalla sezione "Gestione Rilievi" per poterne associare uno nuovo.');
            return;
        }
        const modal = this.modalService.open(ToolkitGestioneOperaModalPianoRilieviComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.formOpera = this.formGroup;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.formGroup.get('idRilievo')?.setValue(result.idRilievo);
                if(this.operaService.operaSession.idOperaOrig === null || this.operaService.operaSession.idOperaOrig === undefined) {
                    this.formGroup.get('provenienza')?.setValue(result.nome);
                }
                this.operaService.update(this.formGroup.getRawValue()).subscribe(()=> {
                    this.rilievoService.read(result.idRilievo).subscribe((item: Rilievo) => {
                        this.item = item;
                        this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    });
                });
                  
            }
        }).catch(e => {});
    }


    public goToRilievo(idRilievo: number) {
        this.router.navigate(['private/gestione-rilievo/dettaglio', idRilievo]);
    }

}
